/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSceneRequestBody
 */
export interface CreateSceneRequestBody {
    /**
     * 
     * @type {number}
     * @memberof CreateSceneRequestBody
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSceneRequestBody
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSceneRequestBody
     */
    note?: string;
}

export function CreateSceneRequestBodyFromJSON(json: any): CreateSceneRequestBody {
    return CreateSceneRequestBodyFromJSONTyped(json, false);
}

export function CreateSceneRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSceneRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization_id'],
        'label': json['label'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CreateSceneRequestBodyToJSON(value?: CreateSceneRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
        'label': value.label,
        'note': value.note,
    };
}

